import LayoutBasic from "@/views/layouts/LayoutBasic";
import statisticsOrders from "@/views/statistics/orders";
import StatisticsPeriod from "@/views/statistics/Period";
import StatisticsDrugs from "@/views/statistics/Drugs";
import ManagersRating from '@/views/admin/analitics/ManagersRating';
import StatisticProfit from '@/views/admin/analitics/StatisticProfit';
import OrdersStatistics from '@/views/admin/analitics/OrdersStatistics.vue';
import AutolistOverStore from '@/views/admin/autolists/overStore.vue';
import OrdersGraph from '@/views/admin/analitics/OrdersGraph.vue';
import PostDirections from "@/views/statistics/PostDirections.vue";
import StatisticsDetailedOrders from "@/views/statistics/StatisticsDetailedOrders.vue";
import Statistics003 from '@/views/statistics/003ms.vue'
import StatisticsDrugsScan from '@/views/statistics/Scan.vue';
import EmptyLayout from "@/views/layouts/EmptyLayout.vue";
import StatisticsRejectedOrders from "@/views/statistics/orders/Rejected.vue";
import Chats from '@/views/statistics/orders/Chats.vue';
import ManagerActivities from '@/views/admin/analitics/ManagersActivities.vue';
import AnalyticsStat003Drugs from '@/views/statistics/003ms.vue';
import ScanTasksDone from "@/views/admin/analitics/ScanTasksDone.vue";
import StatisticsDrugsTasks from '@/views/admin/analitics/Tasks.vue';
import SalePeriod from '@/views/analytics/SalePeriod.vue';

const routes = [
  {
    path: '/statistics',
    component: LayoutBasic, // Change the desired Layout here,
    meta: {requiresAuth: true},
    children: [
      {
        path: 'orders',
        component: EmptyLayout,
        meta: {requiresAuth: true},
        children: [{
          path: 'all',
          component: statisticsOrders,
          name: 'statisticsOrders',
          meta: {
            permission: 'statistics/orders'
          },
        },
          {
            path: 'chats',
            component: Chats,
            name: 'StatisticsChats',
            meta: {
              permission: 'statistics/chats'
            },
          },
          {
            path: 'rejected',
            component: StatisticsRejectedOrders,
            name: 'StatisticsRejectedOrders',
            meta: {
              permission: 'statistics/orders/rejected'
            },
          }]
      },
      {
        path: 'detailedorders',
        component: StatisticsDetailedOrders,
        name: 'statisticsDetailedOrders',
        meta: {
          permission: 'statistics/detailedorders'
        }
      },
      {
        path: 'postdirections',
        component: PostDirections,
        name: 'statisticsPostDirections',
        meta: {
          permission: 'statistics/postdirections'
        }
      },
      {
        path: 'period',
        component: StatisticsPeriod,
        name: 'StatisticsPeriod',
        meta: {
          permission: 'statistics/period'
        }
      },
      {
        path: 'drugs',
        component: StatisticsDrugs,
        name: 'StatisticsDrugs',
        meta: {
          permission: 'statistics/drugs'
        }
      },
      {
        path: '003',
        component: Statistics003,
        name: 'Statistics003Drugs',
        meta: {
          permission: 'statistics/003'
        }
      },
    ]
  },
  {
    path: '/analytics',
    component: LayoutBasic, // Change the desired Layout here,
    meta: {requiresAuth: true},
    children: [
      {
        path: 'nomenclature',
        component: EmptyLayout,
        children: [
          {
            path: 'stat003',
            name: 'AnalyticsStat003Drugs',
            component: AnalyticsStat003Drugs,
            meta: {
              permission: 'analytics/nomenclature/stat003'
            }
          },
          {
            path: 'scan',
            component: StatisticsDrugsScan,
            name: 'StatisticsDrugsScan',
            meta: {
              permission: 'analytics/nomenclature/scan'
            }
          },
          {
            path: 'tasks',
            component: StatisticsDrugsTasks,
            name: 'StatisticsDrugsTasks',
            meta: {
              permission: 'analytics/nomenclature/tasks'
            }
          },
          {
            path: 'scan/tasks/done',
            component: ScanTasksDone,
            name: 'StatisticsDrugsScanTasksDone',
            meta: {
              permission: 'analytics/nomenclature/scan/tasks/done'
            }
          },
        ]
      },
      {
        path: 'manager/activities',
        name: 'ManagerActivities',
        component: ManagerActivities
      },
      {
        path: 'ratings',
        name: 'ManagersRating',
        component: ManagersRating
      },
      {
        path: 'profit',
        name: 'StatisticProfit',
        component: StatisticProfit
      },
      {
        path: 'orderstatistics',
        name: 'OrdersStatistics',
        component: OrdersStatistics
      },
      {
        path: 'overstore',
        name: 'AutolistOverStore',
        component: AutolistOverStore
      },
      {
        path: 'ordersgraph',
        name: 'OrdersGraph',
        component: OrdersGraph
      },
      {
        path: 'drugs/sales',
        name: 'SalePeriod',
        component: SalePeriod
      },
    ]
  }
]

export default routes;
